// i18n translations for La Caravelle — 7 languages
// Dish names are kept in French (international restaurant practice). Only UI + section labels are translated.

export const LANGS = [
  { code: "fr", label: "Français", flag: "FR" },
  { code: "en", label: "English", flag: "EN" },
  { code: "de", label: "Deutsch", flag: "DE" },
  { code: "es", label: "Español", flag: "ES" },
  { code: "it", label: "Italiano", flag: "IT" },
  { code: "pt", label: "Português", flag: "PT" },
  { code: "nl", label: "Nederlands", flag: "NL" },
];

export const TRANSLATIONS = {
  fr: {
    nav: {
      accueil: "Accueil",
      restaurant: "Carte Restaurant",
      petitDejeuner: "Petit Déjeuner",
      gourmande: "Carte Gourmande",
    },
    common: {
      narbonne: "Narbonne",
      reserve: "Réserver",
      reserveTable: "Réserver une table",
      call: "Appeler",
      write: "Écrire",
      ourCards: "Nos cartes",
      ourCardsTitle: "Trois cartes,",
      ourCardsTitleItalic: "une seule maison.",
      galleryOverline: "Le lieu",
      galleryTitle: "La Caravelle,",
      galleryTitleItalic: "en images.",
      house: "La maison",
      houseTitle: "Le goût du large,",
      houseTitleItalic: "l'élégance du calme.",
      houseP1: "À deux pas de la Méditerranée, La Caravelle accueille les amoureux d'iode et de douceur. Pareillade généreuse, crêpes signatures, glaces artisanales et cocktails inspirés — la maison cultive une cuisine sincère, vivante, à l'image du bord de mer qui l'entoure.",
      houseP2: "Du petit-déjeuner face à l'horizon aux dîners en terrasse, chaque moment trouve sa carte. À vous de choisir la vôtre.",
      heroOverline: "Restaurant · Narbonne-Plage",
      heroTitle: "La Caravelle",
      heroTitleItalic: "face à la mer.",
      heroSub: "Après une longue absence, La Caravelle a rouvert le 14 mai 2026.",
      discoverCard: "Découvrir la carte",
      seeFullCard: "Voir la carte complète",
      explore: "Explorer la carte",
      signatures: "Les signatures",
      signaturesTitle: "La mer dans l'assiette,",
      signaturesTitleItalic: "la douceur en dessert.",
      visitUs: "Venir nous voir",
      visitTitle: "À table,",
      visitTitleItalic: "à toute heure.",
      address: "Adresse",
      hours: "Horaires",
      reservations: "Réservations",
      everyday: "Tous les jours",
      contact: "Contact",
      cardsLabel: "Cartes",
      footerTagline: "Restaurant face à la Méditerranée. Cuisine de la mer, petit déjeuner et carte gourmande dans une ambiance épurée et chaleureuse.",
      footerQuote: "« Le goût du large, l'élégance du calme. »",
      scroll: "SCROLL",
      bookTable: "Réservez votre table",
      bookTableItalic: "au bord de l'eau.",
      openEveryday: "Ouvert tous les jours · 9h00 – 00h00",
      writeUs: "Nous écrire",
      cardLabel: "Carte",
      specialty: "Spécialité",
      specialtyDish: "Pareillade de la mer",
      specialtyDesc: "Poisson entier, saumon, seiche, gambas — 32 €",
      marquee: ["Narbonne · Bord de mer", "Cuisine de la mer", "Ouvert tous les jours", "9h – 00h", "Depuis le front de mer"],
    },
    carteSubtitles: {
      restaurant: "Cuisine de bord de mer, généreuse et raffinée",
      petitDejeuner: "Commencez la journée face à la mer",
      gourmande: "Cocktails, douceurs glacées et plaisirs sucrés",
    },
    cardSubs: {
      restaurant: "Fruits de mer, poissons, viandes",
      petitDejeuner: "Formules, cafés, matcha & ube",
      gourmande: "Cocktails, glaces, crêpes & gaufres",
    },
    sections: {
      "Fruits de Mer": "Fruits de Mer",
      "Les Entrées": "Les Entrées",
      "Salades Repas": "Salades Repas",
      "Poissons & Fruits de Mer": "Poissons & Fruits de Mer",
      "Viandes": "Viandes",
      "Burgers": "Burgers",
      "Planches à Partager": "Planches à Partager",
      "Les Tapas": "Les Tapas",
      "Desserts": "Desserts",
      "Menu du Jour — 23 €": "Menu du Jour — 23 €",
      "Nos Formules": "Nos Formules",
      "Boissons Chaudes": "Boissons Chaudes",
      "Matcha & Ube": "Matcha & Ube",
      "Jus & Pressés": "Jus & Pressés",
      "Cocktails Alcoolisés — 9,90 €": "Cocktails Alcoolisés — 9,90 €",
      "Mocktails — 8 €": "Mocktails — 8 €",
      "Smoothies — 7,80 €": "Smoothies — 7,80 €",
      "Milkshakes (avec chantilly)": "Milkshakes (avec chantilly)",
      "Frappés & Thés Glacés": "Frappés & Thés Glacés",
      "Crêpes & Gaufres": "Crêpes & Gaufres",
      "Nos Signatures (Crêpes & Gaufres)": "Nos Signatures (Crêpes & Gaufres)",
      "Glacier — À composer": "Glacier — À composer",
      "Coupes Signatures — 11,90 €": "Coupes Signatures — 11,90 €",
      "Coupes Alcoolisées — 11,90 €": "Coupes Alcoolisées — 11,90 €",
      "Apéritifs": "Apéritifs",
      "Bières Pression (25 cl)": "Bières Pression (25 cl)",
      "Bières Bouteilles (33 cl)": "Bières Bouteilles (33 cl)",
      "Alcools (4 cl)": "Alcools (4 cl)",
      "Digestifs (4 cl)": "Digestifs (4 cl)",
      "Vins Blancs": "Vins Blancs",
      "Vins Rosés": "Vins Rosés",
      "Vins Rouges": "Vins Rouges",
    },
  },

  en: {
    nav: { accueil: "Home", restaurant: "Restaurant", petitDejeuner: "Breakfast", gourmande: "Gourmet" },
    common: {
      narbonne: "Narbonne", reserve: "Book", reserveTable: "Book a table", call: "Call", write: "Email",
      ourCards: "Our menus", ourCardsTitle: "Three menus,", ourCardsTitleItalic: "one house.",
      galleryOverline: "The place", galleryTitle: "La Caravelle,", galleryTitleItalic: "in pictures.",
      house: "The house", houseTitle: "A taste of the open sea,", houseTitleItalic: "the elegance of calm.",
      houseP1: "Steps from the Mediterranean, La Caravelle welcomes lovers of salt air and gentle pleasures. Generous seafood platters, signature crêpes, artisan ice creams and inspired cocktails — sincere, lively cuisine, true to the seaside that surrounds it.",
      houseP2: "From breakfast facing the horizon to dinners on the terrace, every moment has its menu. The choice is yours.",
      heroOverline: "Restaurant · Narbonne-Plage", heroTitle: "La Caravelle", heroTitleItalic: "facing the sea.",
      heroSub: "After a long absence, La Caravelle reopened on 14 May 2026.",
      discoverCard: "Discover the menu", seeFullCard: "View the full menu", explore: "Explore the menu",
      signatures: "Signatures", signaturesTitle: "The sea on the plate,", signaturesTitleItalic: "sweetness in dessert.",
      visitUs: "Visit us", visitTitle: "At the table,", visitTitleItalic: "all day long.",
      address: "Address", hours: "Hours", reservations: "Reservations", everyday: "Every day", contact: "Contact", cardsLabel: "Menus",
      footerTagline: "Restaurant facing the Mediterranean. Seaside cuisine, breakfast and gourmet menu in a refined, warm setting.",
      footerQuote: "« A taste of the sea, the elegance of calm. »",
      scroll: "SCROLL", bookTable: "Book your table", bookTableItalic: "by the water.",
      openEveryday: "Open every day · 9:00 – 00:00", writeUs: "Email us",
      cardLabel: "Menu", specialty: "Specialty", specialtyDish: "Seafood Platter (Pareillade)", specialtyDesc: "Whole fish, salmon, cuttlefish, prawns — €32",
      marquee: ["Narbonne · Seaside", "Sea cuisine", "Open every day", "9:00 – 00:00", "On the seafront"],
    },
    carteSubtitles: {
      restaurant: "Seaside cuisine, generous and refined",
      petitDejeuner: "Start your day facing the sea",
      gourmande: "Cocktails, frozen treats and sweet pleasures",
    },
    cardSubs: {
      restaurant: "Seafood, fish, meats",
      petitDejeuner: "Sets, coffees, matcha & ube",
      gourmande: "Cocktails, ice cream, crêpes & waffles",
    },
    sections: {
      "Fruits de Mer": "Seafood", "Les Entrées": "Starters", "Salades Repas": "Main Salads",
      "Poissons & Fruits de Mer": "Fish & Seafood", "Viandes": "Meats", "Burgers": "Burgers",
      "Planches à Partager": "Sharing Boards", "Les Tapas": "Tapas", "Desserts": "Desserts",
      "Menu du Jour — 23 €": "Menu of the Day — €23",
      "Nos Formules": "Our Sets", "Boissons Chaudes": "Hot Drinks", "Matcha & Ube": "Matcha & Ube",
      "Jus & Pressés": "Juices & Pressed",
      "Cocktails Alcoolisés — 9,90 €": "Alcoholic Cocktails — €9.90", "Mocktails — 8 €": "Mocktails — €8",
      "Smoothies — 7,80 €": "Smoothies — €7.80", "Milkshakes (avec chantilly)": "Milkshakes (with whipped cream)",
      "Frappés & Thés Glacés": "Frappés & Iced Teas", "Crêpes & Gaufres": "Crêpes & Waffles",
      "Nos Signatures (Crêpes & Gaufres)": "Signature Crêpes & Waffles",
      "Glacier — À composer": "Ice Cream — Build your own",
      "Coupes Signatures — 11,90 €": "Signature Sundaes — €11.90",
      "Coupes Alcoolisées — 11,90 €": "Alcoholic Sundaes — €11.90",
      "Apéritifs": "Aperitifs",
      "Bières Pression (25 cl)": "Draught Beers (25 cl)",
      "Bières Bouteilles (33 cl)": "Bottled Beers (33 cl)",
      "Alcools (4 cl)": "Spirits (4 cl)",
      "Digestifs (4 cl)": "Digestifs (4 cl)",
      "Vins Blancs": "White Wines",
      "Vins Rosés": "Rosé Wines",
      "Vins Rouges": "Red Wines",
    },
  },

  de: {
    nav: { accueil: "Startseite", restaurant: "Restaurantkarte", petitDejeuner: "Frühstück", gourmande: "Gourmet" },
    common: {
      narbonne: "Narbonne", reserve: "Reservieren", reserveTable: "Tisch reservieren", call: "Anrufen", write: "Schreiben",
      ourCards: "Unsere Karten", ourCardsTitle: "Drei Karten,", ourCardsTitleItalic: "ein Haus.",
      galleryOverline: "Der Ort", galleryTitle: "La Caravelle,", galleryTitleItalic: "in Bildern.",
      house: "Das Haus", houseTitle: "Der Geschmack des Meeres,", houseTitleItalic: "die Eleganz der Ruhe.",
      houseP1: "Nur wenige Schritte vom Mittelmeer entfernt empfängt La Caravelle Liebhaber salziger Luft und sanfter Genüsse. Großzügige Meeresfrüchteplatten, Signature-Crêpes, handgemachtes Eis und inspirierte Cocktails — aufrichtige, lebendige Küche.",
      houseP2: "Vom Frühstück mit Blick auf den Horizont bis zum Abendessen auf der Terrasse: Jeder Moment hat seine Karte.",
      heroOverline: "Restaurant · Narbonne-Plage", heroTitle: "La Caravelle", heroTitleItalic: "am Meer.",
      heroSub: "Nach langer Abwesenheit hat La Caravelle am 14. Mai 2026 wiedereröffnet.",
      discoverCard: "Karte entdecken", seeFullCard: "Vollständige Karte ansehen", explore: "Karte erkunden",
      signatures: "Signature-Gerichte", signaturesTitle: "Das Meer auf dem Teller,", signaturesTitleItalic: "Süße zum Dessert.",
      visitUs: "Besuchen Sie uns", visitTitle: "Zu Tisch,", visitTitleItalic: "den ganzen Tag.",
      address: "Adresse", hours: "Öffnungszeiten", reservations: "Reservierungen", everyday: "Täglich", contact: "Kontakt", cardsLabel: "Karten",
      footerTagline: "Restaurant am Mittelmeer. Meeresküche, Frühstück und Gourmet-Karte in stilvoller, warmer Atmosphäre.",
      footerQuote: "« Der Geschmack des Meeres, die Eleganz der Ruhe. »",
      scroll: "SCROLLEN", bookTable: "Reservieren Sie Ihren Tisch", bookTableItalic: "am Wasser.",
      openEveryday: "Täglich geöffnet · 9:00 – 00:00", writeUs: "Schreiben Sie uns",
      cardLabel: "Karte", specialty: "Spezialität", specialtyDish: "Meeresfrüchteplatte (Pareillade)", specialtyDesc: "Ganzer Fisch, Lachs, Tintenfisch, Garnelen — 32 €",
      marquee: ["Narbonne · Am Meer", "Meeresküche", "Täglich geöffnet", "9:00 – 00:00", "An der Strandpromenade"],
    },
    carteSubtitles: {
      restaurant: "Meeresküche, großzügig und raffiniert",
      petitDejeuner: "Starten Sie den Tag am Meer",
      gourmande: "Cocktails, gefrorene Köstlichkeiten und süße Genüsse",
    },
    cardSubs: {
      restaurant: "Meeresfrüchte, Fisch, Fleisch",
      petitDejeuner: "Menüs, Kaffees, Matcha & Ube",
      gourmande: "Cocktails, Eis, Crêpes & Waffeln",
    },
    sections: {
      "Fruits de Mer": "Meeresfrüchte", "Les Entrées": "Vorspeisen", "Salades Repas": "Hauptsalate",
      "Poissons & Fruits de Mer": "Fisch & Meeresfrüchte", "Viandes": "Fleisch", "Burgers": "Burger",
      "Planches à Partager": "Sharing-Platten", "Les Tapas": "Tapas", "Desserts": "Desserts",
      "Menu du Jour — 23 €": "Tagesmenü — 23 €",
      "Nos Formules": "Unsere Menüs", "Boissons Chaudes": "Heiße Getränke", "Matcha & Ube": "Matcha & Ube",
      "Jus & Pressés": "Säfte & Frisch gepresst",
      "Cocktails Alcoolisés — 9,90 €": "Alkoholische Cocktails — 9,90 €", "Mocktails — 8 €": "Alkoholfreie Cocktails — 8 €",
      "Smoothies — 7,80 €": "Smoothies — 7,80 €", "Milkshakes (avec chantilly)": "Milchshakes (mit Sahne)",
      "Frappés & Thés Glacés": "Frappés & Eistees", "Crêpes & Gaufres": "Crêpes & Waffeln",
      "Nos Signatures (Crêpes & Gaufres)": "Signature-Crêpes & Waffeln",
      "Glacier — À composer": "Eis — Selbst zusammenstellen",
      "Coupes Signatures — 11,90 €": "Signature-Eisbecher — 11,90 €",
      "Coupes Alcoolisées — 11,90 €": "Eisbecher mit Alkohol — 11,90 €",
      "Apéritifs": "Aperitifs",
      "Bières Pression (25 cl)": "Bier vom Fass (25 cl)",
      "Bières Bouteilles (33 cl)": "Flaschenbier (33 cl)",
      "Alcools (4 cl)": "Spirituosen (4 cl)",
      "Digestifs (4 cl)": "Digestifs (4 cl)",
      "Vins Blancs": "Weißweine",
      "Vins Rosés": "Roséweine",
      "Vins Rouges": "Rotweine",
    },
  },

  es: {
    nav: { accueil: "Inicio", restaurant: "Carta Restaurante", petitDejeuner: "Desayuno", gourmande: "Gourmet" },
    common: {
      narbonne: "Narbona", reserve: "Reservar", reserveTable: "Reservar mesa", call: "Llamar", write: "Escribir",
      ourCards: "Nuestras cartas", ourCardsTitle: "Tres cartas,", ourCardsTitleItalic: "una sola casa.",
      galleryOverline: "El lugar", galleryTitle: "La Caravelle,", galleryTitleItalic: "en imágenes.",
      house: "La casa", houseTitle: "El sabor del mar,", houseTitleItalic: "la elegancia de la calma.",
      houseP1: "A dos pasos del Mediterráneo, La Caravelle acoge a los amantes del aire salino y los placeres suaves. Generosas mariscadas, crêpes de autor, helados artesanales y cócteles inspirados — una cocina sincera, viva, fiel al mar que la rodea.",
      houseP2: "Del desayuno frente al horizonte a las cenas en terraza, cada momento tiene su carta. La elección es suya.",
      heroOverline: "Restaurante · Narbonne-Plage", heroTitle: "La Caravelle", heroTitleItalic: "frente al mar.",
      heroSub: "Tras una larga ausencia, La Caravelle reabrió el 14 de mayo de 2026.",
      discoverCard: "Descubrir la carta", seeFullCard: "Ver la carta completa", explore: "Explorar la carta",
      signatures: "Especialidades", signaturesTitle: "El mar en el plato,", signaturesTitleItalic: "la dulzura en el postre.",
      visitUs: "Visítenos", visitTitle: "A la mesa,", visitTitleItalic: "a toda hora.",
      address: "Dirección", hours: "Horario", reservations: "Reservas", everyday: "Todos los días", contact: "Contacto", cardsLabel: "Cartas",
      footerTagline: "Restaurante frente al Mediterráneo. Cocina del mar, desayuno y carta gourmet en un ambiente refinado y cálido.",
      footerQuote: "« El sabor del mar, la elegancia de la calma. »",
      scroll: "SCROLL", bookTable: "Reserve su mesa", bookTableItalic: "a la orilla del agua.",
      openEveryday: "Abierto todos los días · 9:00 – 00:00", writeUs: "Escríbanos",
      cardLabel: "Carta", specialty: "Especialidad", specialtyDish: "Mariscada (Pareillade)", specialtyDesc: "Pescado entero, salmón, sepia, gambas — 32 €",
      marquee: ["Narbona · Costa", "Cocina del mar", "Abierto todos los días", "9:00 – 00:00", "Desde el paseo marítimo"],
    },
    carteSubtitles: {
      restaurant: "Cocina marinera, generosa y refinada",
      petitDejeuner: "Empiece el día frente al mar",
      gourmande: "Cócteles, helados y placeres dulces",
    },
    cardSubs: {
      restaurant: "Mariscos, pescados, carnes",
      petitDejeuner: "Menús, cafés, matcha y ube",
      gourmande: "Cócteles, helados, crêpes y gofres",
    },
    sections: {
      "Fruits de Mer": "Mariscos", "Les Entrées": "Entrantes", "Salades Repas": "Ensaladas principales",
      "Poissons & Fruits de Mer": "Pescados y mariscos", "Viandes": "Carnes", "Burgers": "Hamburguesas",
      "Planches à Partager": "Tablas para compartir", "Les Tapas": "Tapas", "Desserts": "Postres",
      "Menu du Jour — 23 €": "Menú del día — 23 €",
      "Nos Formules": "Nuestros menús", "Boissons Chaudes": "Bebidas calientes", "Matcha & Ube": "Matcha y Ube",
      "Jus & Pressés": "Zumos y prensados",
      "Cocktails Alcoolisés — 9,90 €": "Cócteles con alcohol — 9,90 €", "Mocktails — 8 €": "Cócteles sin alcohol — 8 €",
      "Smoothies — 7,80 €": "Smoothies — 7,80 €", "Milkshakes (avec chantilly)": "Batidos (con nata)",
      "Frappés & Thés Glacés": "Frappés y tés helados", "Crêpes & Gaufres": "Crêpes y gofres",
      "Nos Signatures (Crêpes & Gaufres)": "Crêpes y gofres de la casa",
      "Glacier — À composer": "Heladería — A componer",
      "Coupes Signatures — 11,90 €": "Copas de la casa — 11,90 €",
      "Coupes Alcoolisées — 11,90 €": "Copas con alcohol — 11,90 €",
      "Apéritifs": "Aperitivos",
      "Bières Pression (25 cl)": "Cervezas de barril (25 cl)",
      "Bières Bouteilles (33 cl)": "Cervezas en botella (33 cl)",
      "Alcools (4 cl)": "Licores (4 cl)",
      "Digestifs (4 cl)": "Digestivos (4 cl)",
      "Vins Blancs": "Vinos blancos",
      "Vins Rosés": "Vinos rosados",
      "Vins Rouges": "Vinos tintos",
    },
  },

  it: {
    nav: { accueil: "Home", restaurant: "Carta Ristorante", petitDejeuner: "Colazione", gourmande: "Gourmet" },
    common: {
      narbonne: "Narbonne", reserve: "Prenotare", reserveTable: "Prenotare un tavolo", call: "Chiamare", write: "Scrivere",
      ourCards: "Le nostre carte", ourCardsTitle: "Tre carte,", ourCardsTitleItalic: "una sola casa.",
      galleryOverline: "Il luogo", galleryTitle: "La Caravelle,", galleryTitleItalic: "in immagini.",
      house: "La casa", houseTitle: "Il sapore del mare,", houseTitleItalic: "l'eleganza della calma.",
      houseP1: "A due passi dal Mediterraneo, La Caravelle accoglie gli amanti dell'aria salmastra e dei piaceri delicati. Generosi piatti di mare, crêpes signature, gelati artigianali e cocktail ispirati — una cucina sincera e viva, fedele al mare che la circonda.",
      houseP2: "Dalla colazione di fronte all'orizzonte alle cene in terrazza, ogni momento ha la sua carta. La scelta è vostra.",
      heroOverline: "Ristorante · Narbonne-Plage", heroTitle: "La Caravelle", heroTitleItalic: "di fronte al mare.",
      heroSub: "Dopo una lunga assenza, La Caravelle ha riaperto il 14 maggio 2026.",
      discoverCard: "Scoprire la carta", seeFullCard: "Vedere la carta completa", explore: "Esplorare la carta",
      signatures: "Le specialità", signaturesTitle: "Il mare nel piatto,", signaturesTitleItalic: "la dolcezza nel dessert.",
      visitUs: "Vieni a trovarci", visitTitle: "A tavola,", visitTitleItalic: "a tutte le ore.",
      address: "Indirizzo", hours: "Orari", reservations: "Prenotazioni", everyday: "Tutti i giorni", contact: "Contatti", cardsLabel: "Carte",
      footerTagline: "Ristorante di fronte al Mediterraneo. Cucina di mare, colazione e carta gourmet in un'atmosfera curata e calda.",
      footerQuote: "« Il sapore del mare, l'eleganza della calma. »",
      scroll: "SCROLL", bookTable: "Prenotate il vostro tavolo", bookTableItalic: "in riva al mare.",
      openEveryday: "Aperto tutti i giorni · 9:00 – 00:00", writeUs: "Scriveteci",
      cardLabel: "Carta", specialty: "Specialità", specialtyDish: "Pareillade di mare", specialtyDesc: "Pesce intero, salmone, seppia, gamberi — 32 €",
      marquee: ["Narbonne · Lungomare", "Cucina di mare", "Aperto tutti i giorni", "9:00 – 00:00", "Sul lungomare"],
    },
    carteSubtitles: {
      restaurant: "Cucina di mare, generosa e raffinata",
      petitDejeuner: "Iniziate la giornata di fronte al mare",
      gourmande: "Cocktail, dolci freddi e piaceri zuccherati",
    },
    cardSubs: {
      restaurant: "Frutti di mare, pesce, carni",
      petitDejeuner: "Formule, caffè, matcha e ube",
      gourmande: "Cocktail, gelati, crêpes e waffle",
    },
    sections: {
      "Fruits de Mer": "Frutti di mare", "Les Entrées": "Antipasti", "Salades Repas": "Insalatone",
      "Poissons & Fruits de Mer": "Pesci e frutti di mare", "Viandes": "Carni", "Burgers": "Burger",
      "Planches à Partager": "Taglieri da condividere", "Les Tapas": "Tapas", "Desserts": "Dolci",
      "Menu du Jour — 23 €": "Menù del giorno — 23 €",
      "Nos Formules": "Le nostre formule", "Boissons Chaudes": "Bevande calde", "Matcha & Ube": "Matcha e Ube",
      "Jus & Pressés": "Succhi e spremute",
      "Cocktails Alcoolisés — 9,90 €": "Cocktail alcolici — 9,90 €", "Mocktails — 8 €": "Cocktail analcolici — 8 €",
      "Smoothies — 7,80 €": "Smoothie — 7,80 €", "Milkshakes (avec chantilly)": "Milkshake (con panna)",
      "Frappés & Thés Glacés": "Frappè e tè freddi", "Crêpes & Gaufres": "Crêpes e waffle",
      "Nos Signatures (Crêpes & Gaufres)": "Crêpes e waffle della casa",
      "Glacier — À composer": "Gelateria — Da comporre",
      "Coupes Signatures — 11,90 €": "Coppe della casa — 11,90 €",
      "Coupes Alcoolisées — 11,90 €": "Coppe alcoliche — 11,90 €",
      "Apéritifs": "Aperitivi",
      "Bières Pression (25 cl)": "Birre alla spina (25 cl)",
      "Bières Bouteilles (33 cl)": "Birre in bottiglia (33 cl)",
      "Alcools (4 cl)": "Superalcolici (4 cl)",
      "Digestifs (4 cl)": "Digestivi (4 cl)",
      "Vins Blancs": "Vini bianchi",
      "Vins Rosés": "Vini rosati",
      "Vins Rouges": "Vini rossi",
    },
  },

  pt: {
    nav: { accueil: "Início", restaurant: "Carta Restaurante", petitDejeuner: "Pequeno-almoço", gourmande: "Gourmet" },
    common: {
      narbonne: "Narbonne", reserve: "Reservar", reserveTable: "Reservar mesa", call: "Ligar", write: "Escrever",
      ourCards: "As nossas cartas", ourCardsTitle: "Três cartas,", ourCardsTitleItalic: "uma só casa.",
      galleryOverline: "O lugar", galleryTitle: "La Caravelle,", galleryTitleItalic: "em imagens.",
      house: "A casa", houseTitle: "O sabor do mar,", houseTitleItalic: "a elegância da calma.",
      houseP1: "A dois passos do Mediterrâneo, o La Caravelle acolhe os amantes do ar salgado e dos prazeres suaves. Generosas travessas de marisco, crêpes signature, gelados artesanais e cocktails inspirados — uma cozinha sincera e viva, fiel ao mar que a rodeia.",
      houseP2: "Do pequeno-almoço de frente para o horizonte aos jantares no terraço, cada momento tem a sua carta. A escolha é sua.",
      heroOverline: "Restaurante · Narbonne-Plage", heroTitle: "La Caravelle", heroTitleItalic: "frente ao mar.",
      heroSub: "Após uma longa ausência, o La Caravelle reabriu a 14 de maio de 2026.",
      discoverCard: "Descobrir a carta", seeFullCard: "Ver a carta completa", explore: "Explorar a carta",
      signatures: "Especialidades", signaturesTitle: "O mar no prato,", signaturesTitleItalic: "a doçura na sobremesa.",
      visitUs: "Venha visitar-nos", visitTitle: "À mesa,", visitTitleItalic: "a toda a hora.",
      address: "Morada", hours: "Horário", reservations: "Reservas", everyday: "Todos os dias", contact: "Contacto", cardsLabel: "Cartas",
      footerTagline: "Restaurante frente ao Mediterrâneo. Cozinha do mar, pequeno-almoço e carta gourmet num ambiente refinado e acolhedor.",
      footerQuote: "« O sabor do mar, a elegância da calma. »",
      scroll: "SCROLL", bookTable: "Reserve a sua mesa", bookTableItalic: "à beira-mar.",
      openEveryday: "Aberto todos os dias · 9:00 – 00:00", writeUs: "Escreva-nos",
      cardLabel: "Carta", specialty: "Especialidade", specialtyDish: "Mariscada (Pareillade)", specialtyDesc: "Peixe inteiro, salmão, choco, gambas — 32 €",
      marquee: ["Narbonne · Beira-mar", "Cozinha do mar", "Aberto todos os dias", "9:00 – 00:00", "Na marginal"],
    },
    carteSubtitles: {
      restaurant: "Cozinha do mar, generosa e refinada",
      petitDejeuner: "Comece o dia frente ao mar",
      gourmande: "Cocktails, doces gelados e prazeres açucarados",
    },
    cardSubs: {
      restaurant: "Marisco, peixes, carnes",
      petitDejeuner: "Menus, cafés, matcha e ube",
      gourmande: "Cocktails, gelados, crêpes e waffles",
    },
    sections: {
      "Fruits de Mer": "Marisco", "Les Entrées": "Entradas", "Salades Repas": "Saladas principais",
      "Poissons & Fruits de Mer": "Peixes e marisco", "Viandes": "Carnes", "Burgers": "Hambúrgueres",
      "Planches à Partager": "Tábuas para partilhar", "Les Tapas": "Tapas", "Desserts": "Sobremesas",
      "Menu du Jour — 23 €": "Menu do dia — 23 €",
      "Nos Formules": "Os nossos menus", "Boissons Chaudes": "Bebidas quentes", "Matcha & Ube": "Matcha e Ube",
      "Jus & Pressés": "Sumos e espremidos",
      "Cocktails Alcoolisés — 9,90 €": "Cocktails com álcool — 9,90 €", "Mocktails — 8 €": "Cocktails sem álcool — 8 €",
      "Smoothies — 7,80 €": "Smoothies — 7,80 €", "Milkshakes (avec chantilly)": "Batidos (com chantilly)",
      "Frappés & Thés Glacés": "Frappés e chás gelados", "Crêpes & Gaufres": "Crêpes e waffles",
      "Nos Signatures (Crêpes & Gaufres)": "Crêpes e waffles da casa",
      "Glacier — À composer": "Gelataria — A compor",
      "Coupes Signatures — 11,90 €": "Taças da casa — 11,90 €",
      "Coupes Alcoolisées — 11,90 €": "Taças com álcool — 11,90 €",
      "Apéritifs": "Aperitivos",
      "Bières Pression (25 cl)": "Cervejas de pressão (25 cl)",
      "Bières Bouteilles (33 cl)": "Cervejas em garrafa (33 cl)",
      "Alcools (4 cl)": "Bebidas espirituosas (4 cl)",
      "Digestifs (4 cl)": "Digestivos (4 cl)",
      "Vins Blancs": "Vinhos brancos",
      "Vins Rosés": "Vinhos rosés",
      "Vins Rouges": "Vinhos tintos",
    },
  },

  nl: {
    nav: { accueil: "Home", restaurant: "Restaurantkaart", petitDejeuner: "Ontbijt", gourmande: "Gourmet" },
    common: {
      narbonne: "Narbonne", reserve: "Reserveren", reserveTable: "Een tafel reserveren", call: "Bellen", write: "Mailen",
      ourCards: "Onze kaarten", ourCardsTitle: "Drie kaarten,", ourCardsTitleItalic: "één huis.",
      house: "Het huis", houseTitle: "De smaak van de zee,", houseTitleItalic: "de elegantie van de rust.",
      houseP1: "Op twee passen van de Middellandse Zee verwelkomt La Caravelle liefhebbers van zilte lucht en zachte genoegens. Royale visschotels, signature pannenkoeken, ambachtelijk ijs en geïnspireerde cocktails — een oprechte, levendige keuken.",
      houseP2: "Van het ontbijt met zicht op de horizon tot diners op het terras: elk moment heeft zijn kaart. De keuze is aan u.",
      heroOverline: "Restaurant · Narbonne-Plage", heroTitle: "La Caravelle", heroTitleItalic: "aan zee.",
      heroSub: "Na een lange afwezigheid heeft La Caravelle op 14 mei 2026 heropend.",
      discoverCard: "Ontdek de kaart", seeFullCard: "Bekijk de volledige kaart", explore: "Verken de kaart",
      signatures: "Specialiteiten", signaturesTitle: "De zee op het bord,", signaturesTitleItalic: "zoetheid in het dessert.",
      visitUs: "Kom langs", visitTitle: "Aan tafel,", visitTitleItalic: "de hele dag.",
      address: "Adres", hours: "Openingstijden", reservations: "Reserveringen", everyday: "Elke dag", contact: "Contact", cardsLabel: "Kaarten",
      footerTagline: "Restaurant aan de Middellandse Zee. Zeekeuken, ontbijt en gourmetkaart in een verfijnde, warme sfeer.",
      footerQuote: "« De smaak van de zee, de elegantie van de rust. »",
      scroll: "SCROLL", bookTable: "Reserveer uw tafel", bookTableItalic: "aan het water.",
      openEveryday: "Elke dag geopend · 9:00 – 00:00", writeUs: "Stuur ons een mail",
      cardLabel: "Kaart", specialty: "Specialiteit", specialtyDish: "Zeevruchtenschotel (Pareillade)", specialtyDesc: "Hele vis, zalm, inktvis, gamba's — € 32",
      marquee: ["Narbonne · Aan zee", "Zeekeuken", "Elke dag geopend", "9:00 – 00:00", "Aan de boulevard"],
    },
    carteSubtitles: {
      restaurant: "Zeekeuken, royaal en verfijnd",
      petitDejeuner: "Begin de dag aan zee",
      gourmande: "Cocktails, ijs en zoete genoegens",
    },
    cardSubs: {
      restaurant: "Zeevruchten, vis, vlees",
      petitDejeuner: "Formules, koffies, matcha & ube",
      gourmande: "Cocktails, ijs, pannenkoeken & wafels",
    },
    sections: {
      "Fruits de Mer": "Zeevruchten", "Les Entrées": "Voorgerechten", "Salades Repas": "Maaltijdsalades",
      "Poissons & Fruits de Mer": "Vis & zeevruchten", "Viandes": "Vlees", "Burgers": "Burgers",
      "Planches à Partager": "Deelplanken", "Les Tapas": "Tapas", "Desserts": "Desserts",
      "Menu du Jour — 23 €": "Menu van de dag — € 23",
      "Nos Formules": "Onze formules", "Boissons Chaudes": "Warme dranken", "Matcha & Ube": "Matcha & Ube",
      "Jus & Pressés": "Sappen & versgeperst",
      "Cocktails Alcoolisés — 9,90 €": "Alcoholische cocktails — € 9,90", "Mocktails — 8 €": "Mocktails — € 8",
      "Smoothies — 7,80 €": "Smoothies — € 7,80", "Milkshakes (avec chantilly)": "Milkshakes (met slagroom)",
      "Frappés & Thés Glacés": "Frappés & ijsthee", "Crêpes & Gaufres": "Pannenkoeken & wafels",
      "Nos Signatures (Crêpes & Gaufres)": "Signature pannenkoeken & wafels",
      "Glacier — À composer": "IJs — Stel zelf samen",
      "Coupes Signatures — 11,90 €": "Signature ijscoupes — € 11,90",
      "Coupes Alcoolisées — 11,90 €": "IJscoupes met alcohol — € 11,90",
      "Apéritifs": "Aperitieven",
      "Bières Pression (25 cl)": "Bier van de tap (25 cl)",
      "Bières Bouteilles (33 cl)": "Flesbier (33 cl)",
      "Alcools (4 cl)": "Sterke drank (4 cl)",
      "Digestifs (4 cl)": "Digestieven (4 cl)",
      "Vins Blancs": "Witte wijnen",
      "Vins Rosés": "Roséwijnen",
      "Vins Rouges": "Rode wijnen",
    },
  },
};
